'use client';

export {
    TabsContent,
    TabsList,
    TabsRoot,
    TabsTrigger,
    type TabsTriggerProps,
    tabsTriggerVariants,
} from '@paypoteam/page-components';
